<ng-template class="theme-modal" #comboModal let-modal>
  <div class="modal-content quick-view-modal">
    <div class="modal-body">
      <button
        type="button"
        class="close"
        (click)="modal.dismiss('Cross click')"
      >
        <span aria-hidden="true">&times;</span>
      </button>
      <div class="orders">
        <div class="ordersheader">Make your combo <span>(10 items) </span></div>
        <div class="orderlist">
          <div class="itembox">
            <!-- <div class="pr-4">1</div> -->
            <div class="img-div">
              <img src="assets/images/product/vegetables/anjur.jpg" />
            </div>
            <div class="itemdetails">
              <!-- <div class="itempromo">41% OFF</div> -->
              <div class="row pt-1">
                <div class="col-5">
                  <span class="pname">మేడిపండు Anjeer</span>
                </div>
                <div class="col-2">
                  <span class="itemgrams">250gms</span>
                </div>
                <div class="col-2 text-right">
                  <span class="itemPrice font-weight-bold">₹ 90 </span>
                </div>
                <div class="col-3 text-right">
                  <span id="div2" class="add">ADD</span>
                </div>
              </div>
            </div>
          </div>
          <div class="itembox">
            <!-- <div class="pr-4">1</div> -->
            <div class="img-div">
              <img src="assets/images/product/vegetables/anjur.jpg" />
            </div>
            <div class="itemdetails">
              <!-- <div class="itempromo">41% OFF</div> -->
              <div class="row pt-1">
                <div class="col-5">
                  <span class="pname">మేడిపండు Anjeer</span>
                </div>
                <div class="col-2">
                  <span class="itemgrams">250gms</span>
                </div>
                <div class="col-2 text-right">
                  <span class="itemPrice font-weight-bold">₹ 90 </span>
                </div>
                <div class="col-3 text-right">
                  <span id="div2" class="add">ADD</span>
                </div>
              </div>
            </div>
          </div>
          <div class="itembox">
            <!-- <div class="pr-4">1</div> -->
            <div class="img-div">
              <img src="assets/images/product/vegetables/anjur.jpg" />
            </div>
            <div class="itemdetails">
              <!-- <div class="itempromo">41% OFF</div> -->
              <div class="row pt-1">
                <div class="col-5">
                  <span class="pname">మేడిపండు Anjeer</span>
                </div>
                <div class="col-2">
                  <span class="itemgrams">250gms</span>
                </div>
                <div class="col-2 text-right">
                  <span class="itemPrice font-weight-bold">₹ 90 </span>
                </div>
                <div class="col-3 text-right">
                  <span id="div2" class="add">ADD</span>
                </div>
              </div>
            </div>
          </div>
          <div class="itembox">
            <!-- <div class="pr-4">1</div> -->
            <div class="img-div">
              <img src="assets/images/product/vegetables/anjur.jpg" />
            </div>
            <div class="itemdetails">
              <!-- <div class="itempromo">41% OFF</div> -->
              <div class="row pt-1">
                <div class="col-5">
                  <span class="pname">మేడిపండు Anjeer</span>
                </div>
                <div class="col-2">
                  <span class="itemgrams">250gms</span>
                </div>
                <div class="col-2 text-right">
                  <span class="itemPrice font-weight-bold">₹ 90 </span>
                </div>
                <div class="col-3 text-right">
                  <span id="div2" class="add">ADD</span>
                </div>
              </div>
            </div>
          </div>
          <div class="itembox">
            <!-- <div class="pr-4">1</div> -->
            <div class="img-div">
              <img src="assets/images/product/vegetables/anjur.jpg" />
            </div>
            <div class="itemdetails">
              <!-- <div class="itempromo">41% OFF</div> -->
              <div class="row pt-1">
                <div class="col-5">
                  <span class="pname">మేడిపండు Anjeer</span>
                </div>
                <div class="col-2">
                  <span class="itemgrams">250gms</span>
                </div>
                <div class="col-2 text-right">
                  <span class="itemPrice font-weight-bold">₹ 90 </span>
                </div>
                <div class="col-3 text-right">
                  <span id="div2" class="add">ADD</span>
                </div>
              </div>
            </div>
          </div>
          <div class="itembox">
            <!-- <div class="pr-4">1</div> -->
            <div class="img-div">
              <img src="assets/images/product/vegetables/anjur.jpg" />
            </div>
            <div class="itemdetails">
              <!-- <div class="itempromo">41% OFF</div> -->
              <div class="row pt-1">
                <div class="col-5">
                  <span class="pname">మేడిపండు Anjeer</span>
                </div>
                <div class="col-2">
                  <span class="itemgrams">250gms</span>
                </div>
                <div class="col-2 text-right">
                  <span class="itemPrice font-weight-bold">₹ 90 </span>
                </div>
                <div class="col-3 text-right">
                  <span id="div2" class="add">ADD</span>
                </div>
              </div>
            </div>
          </div>
          <div class="itembox">
            <!-- <div class="pr-4">1</div> -->
            <div class="img-div">
              <img src="assets/images/product/vegetables/anjur.jpg" />
            </div>
            <div class="itemdetails">
              <!-- <div class="itempromo">41% OFF</div> -->
              <div class="row pt-1">
                <div class="col-5">
                  <span class="pname">మేడిపండు Anjeer</span>
                </div>
                <div class="col-2">
                  <span class="itemgrams">250gms</span>
                </div>
                <div class="col-2 text-right">
                  <span class="itemPrice font-weight-bold">₹ 90 </span>
                </div>
                <div class="col-3 text-right">
                  <span id="div2" class="add">ADD</span>
                </div>
              </div>
            </div>
          </div>
          <div class="itembox">
            <!-- <div class="pr-4">1</div> -->
            <div class="img-div">
              <img src="assets/images/product/vegetables/anjur.jpg" />
            </div>
            <div class="itemdetails">
              <!-- <div class="itempromo">41% OFF</div> -->
              <div class="row pt-1">
                <div class="col-5">
                  <span class="pname">మేడిపండు Anjeer</span>
                </div>
                <div class="col-2">
                  <span class="itemgrams">250gms</span>
                </div>
                <div class="col-2 text-right">
                  <span class="itemPrice font-weight-bold">₹ 90 </span>
                </div>
                <div class="col-3 text-right">
                  <span id="div2" class="add">ADD</span>
                </div>
              </div>
            </div>
          </div>
          <div class="itembox">
            <!-- <div class="pr-4">1</div> -->
            <div class="img-div">
              <img src="assets/images/product/vegetables/anjur.jpg" />
            </div>
            <div class="itemdetails">
              <!-- <div class="itempromo">41% OFF</div> -->
              <div class="row pt-1">
                <div class="col-5">
                  <span class="pname">మేడిపండు Anjeer</span>
                </div>
                <div class="col-2">
                  <span class="itemgrams">250gms</span>
                </div>
                <div class="col-2 text-right">
                  <span class="itemPrice font-weight-bold">₹ 90 </span>
                </div>
                <div class="col-3 text-right">
                  <span id="div2" class="add">ADD</span>
                </div>
              </div>
            </div>
          </div>

          <div class="itembox">
            <!-- <div class="pr-4">1</div> -->
            <div class="img-div">
              <img src="assets/images/product/vegetables/anjur.jpg" />
            </div>
            <div class="itemdetails">
              <!-- <div class="itempromo">41% OFF</div> -->
              <div class="row pt-1">
                <div class="col-5">
                  <span class="pname">మేడిపండు Anjeer</span>
                </div>
                <div class="col-2">
                  <span class="itemgrams">250gms</span>
                </div>
                <div class="col-2 text-right">
                  <span class="itemPrice font-weight-bold">₹ 90 </span>
                </div>
                <div class="col-3 text-right">
                  <span id="div2" class="add">ADD</span>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div class="ordersfooter">
          <div class="row">
            <div class="col-md-6 col-sm-6 col-xs-6 footer-price">
              Total Items: 20
            </div>
            <div class="col-md-6 col-sm-6 col-xs-6 text-right">Price: 400</div>
          </div>
        </div>
      </div>
    </div>
  </div>
</ng-template>
